export default "__VITE_ASSET__80d91f1e__"